import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=5d8e9a3e&scoped=true"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"
import style0 from "./Simple.vue?vue&type=style&index=0&id=5d8e9a3e&prod&lang=css"
import style1 from "./Simple.vue?vue&type=style&index=1&id=5d8e9a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8e9a3e",
  null
  
)

export default component.exports